import {MainVideoState} from "../definitions/MainVideoState";
import {PlayerMode} from "../constants/PlayerMode";

export const seekCurrentTimeOnNextVideoLoad = (state: MainVideoState) => {
    state.playerMode = PlayerMode.WaitingForIdenticalVideoLoad;
};
